const language = {
    en: {
        //data
        pdfFile: 'PDF file',
        xmlFile: 'XML file',
        fileContent: 'XML file content',
        serial: 'Serial',
        folio: 'Folio',
        created: 'Created',
        voucherType: 'Voucher type',
        subTotal: 'Subtotal',
        currency: 'Currency',
        total: 'Total',
        placeExpedition: 'Place of expedition',
        issuing: 'Issuer',
        recipient: 'Recipient',
        name: 'Name',
        taxId: 'Tax ID',
        totals: 'Totals',
        payment: 'Payment',
        paymentDate: 'Payment date',
        paymentWay: 'Payment way',
        amount: 'Amount',
        relatedDocuments: 'Related documents',
        previousBalanceAmount: 'Previous balance amount',
        amountPaid: 'Amount paid',
        outstandingBalanceAmount: 'Outstanding balance amount',
        status: 'Status',
        related: 'Related',
        noRelated: 'Unrelated',
        invoice: 'Invoice',
        relatedDocument: 'Related Document',
        validation: 'Validation',
        income: 'Ingreso',
        expense: 'Egreso',
        paymentReceipt: 'Complemento de pago',
        //action
        preview: 'Preview',
        download: 'Download',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        yes: 'Yes',
        no: 'No',
        cancel: 'Cancel',
        //questions
        alreadyRegister: 'The payment receipt (CDP) is already registered<br>Do you want to relate it with this payment?',
        updatePdfQuestion: 'Are you sure you want to update the PDF file?',
        deletePaymentRelation: 'Are you sure you want to delete the related payment receipt (CDP)?',
        deleteRelatedDocumentRelation: 'This action will delete the relationship between the payment receipt (CDP), the related documents and their payments',
        //error
        anErrorHasOccurred: 'An error has occurred!',
        tryAgainError: 'Try again, if the issue persists please contact support',
        incorrectDocument: 'The document is incorrect',
        incorrectIssuingData: 'The issuer name or tax ID is incorrect',
        incorrectRecipientData: 'The recipient name or tax ID is incorrect',
        attention: 'Attention!',
        relatedDocumentError: 'There are no related documents for this payment receipt (CDP)',
        relatedPaymentError: 'There are no related payments for this payment receipt (CDP)',
        voucherTypeError: (voucherType, voucherName) => `The voucher type ${ voucherType } (${ voucherName }) is incorrect`,
        deleteDisable: 'The delete option is disabled',
        noAvailablePayment: 'There is no available payment to relate',
        paymentReceiptAlreadyExists: 'The payment receipt (CDP) already exist',
        selectFile: 'Select a file',
        paymentReceiptOutdated: 'The payment receipt (CDP) information is outdated, try again',
        relatedAmountGreaterThan: 'The related amount is greater than invoice\'s balance to relate',
        invoiceAlreadyExist: 'The invoice was already registered',
        paymentAlreadyRelated: 'The payment is already related to another payment receipt (CDP)',
        noRelatedDocumentsAvailable: 'The payment receipt (CDP) does not have related documents available to relate',
        noRelatedPaymentsAvailable: 'The payment receipt (CDP) does not have payments available to relate',
        noPaymentReceiptInvoiceRelationship: 'The relationship between the payment and the payment receipt (CDP) was not found',
        paymentReceiptShowErrorTitle: 'Error in payment receipt (CDP) details',
        paymentReceiptShowErrorMessage: 'The payment receipt (CDP) record was updated in another session',
        paymentReceiptNoExists: 'The payment receipt (CDP) does not exist',
        relatedPaymentDateError: 'The payment date is ahead of the payment receipt (CDP) date',
        reloadThePage: 'reload the page',
        fileNoExists: 'The file does not exists',
        accessUnauthorized: 'Access denied. Perhaps the session was closed',
        paymentReceiptInvalid: 'The requirements to save/relate the payment receipt (CDP) are incomplete',
        //success
        saveSuccesfully: 'The payment receipt (CDP) was saved successfully'
    },
    es: {
        //data
        pdfFile: 'Archivo PDF',
        xmlFile: 'Archivo XML',
        fileContent: 'Contenido del archivo XML',
        serial: 'Serie',
        folio: 'Folio',
        created: 'Fecha de timbrado',
        voucherType: 'Tipo de comprobante',
        subTotal: 'Subtotal',
        currency: 'Moneda',
        total: 'Total',
        placeExpedition: 'Lugar de expedición',
        issuing: 'Emisor',
        recipient: 'Receptor',
        name: 'Nombre',
        taxId: 'RFC',
        totals: 'Totales',
        payment: 'Pago',
        paymentDate: 'Fecha de pago',
        paymentWay: 'Forma de pago',
        amount: 'Importe',
        relatedDocuments: 'Documentos relacionados',
        previousBalanceAmount: 'Importe de saldo anterior',
        amountPaid: 'Importe pagado',
        outstandingBalanceAmount: 'Importe de saldo insoluto',
        status: 'Estatus',
        related: 'Relacionado',
        noRelated: 'Sin relacionar',
        invoice: 'Factura',
        relatedDocument: 'Documento relacionado',
        validation: 'Validación',
        income: 'Ingreso',
        expense: 'Egreso',
        paymentReceipt: 'Complemento de pago',
        //action
        preview: 'Previsualizar',
        download: 'Descargar',
        edit: 'Modificar',
        delete: 'Eliminar',
        save: 'Guardar',
        yes: 'Sí',
        no: 'No',
        cancel: 'Cancelar',
        //questions
        alreadyRegister: 'El complemento de pago ya se encuentra registrado en el sistema<br>¿Deseas relacionarlo con este pago?',
        updatePdfQuestion: '¿Estás seguro de actualizar el pdf?',
        deletePaymentRelation: '¿Esta seguro de eliminar el complemento de pago relacionado?',
        deleteRelatedDocumentRelation: 'Esta acción eliminara la relacion entre el complemento de pago, documentos relacionados y sus pagos registrados',
        //error
        anErrorHasOccurred: '¡Ha ocurrido un error!',
        tryAgainError: 'Vuelve a intentarlo, si el problema persiste contacta a soporte',
        incorrectDocument: 'El documento no es correcto',
        incorrectIssuingData: 'El nombre o RFC del emisor no coincide',
        incorrectRecipientData: 'El nombre o RFC del receptor no coincide',
        attention: '¡Atención!',
        relatedDocumentError: 'No se encontro una factura relacionada al complemento de pago',
        relatedPaymentError: 'No se encontro un pago relacionado al complemento de pago',
        voucherTypeError: (voucherType, voucherName) => `El tipo de comprobante ${ voucherType } (${ voucherName }) es incorrecto`,
        deleteDisable: 'No esta habilitada la opción de eliminar',
        noAvailablePayment: 'No se encontró un pago disponible para relacionar',
        paymentReceiptAlreadyExists: 'El complemento de pago ya existe',
        selectFile: 'Seleccione un archivo',
        paymentReceiptOutdated: 'La información del complemento de pago fue actualizada en otra sesión',
        relatedAmountGreaterThan: 'El monto a relacionar es mayor al saldo para relacionar de la factura',
        invoiceAlreadyValidated: 'Esta factura ya fue validada',
        paymentAlreadyRelated: 'El pago ya esta relacionado a un complemento de pago',
        noRelatedDocumentsAvailable: 'El complemento de pago no tiene documentos relacionados disponibles para relacionar',
        noRelatedPaymentsAvailable: 'El complemento de pago no tiene pagos disponibles para relacionar',
        noPaymentReceiptInvoiceRelationship: 'La relación entre la factura y el complemento de pago no se encontró',
        paymentReceiptShowErrorTitle: 'Error al cargar el detalle del complemento de pago',
        paymentReceiptShowErrorMessage: 'El registro del complemento de pago fue actualizado en otra sesión',
        paymentReceiptNoExists: 'El complemento de pago no existe',
        relatedPaymentDateError: 'La fecha del pago es despues de la fecha de creacion del complemento de pago',
        reloadThePage: 'recargue la pagina',
        fileNoExists: 'El archivo no existe',
        accessUnauthorized: 'Acceso denegado Posiblemente la sesión fue cerrada',
        paymentReceiptInvalid: 'No se cumplen los requerimientos necesarios para guardar/relacionar el complemento de pago',
        //success
        saveSuccesfully: 'El complemento de pago se guardo exitosamente'
    }
};

export default language;